import React from 'react';

const Label = ({ text, className }) => {
    return (
        <label className={`block text-white ${className}`}>
            {text}
        </label>
    );
};

export default Label;
